import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the TextCookiesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-text-cookies',
  templateUrl: 'text-cookies.html',
})
export class TextCookiesPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TextCookiesPage');
  }

}



// WEBPACK FOOTER //
// /src/pages/textPages/text-cookies/text-cookies.ts